import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyDwvAuTLKD7csp8ceAbTXSiTJNS3JpIZ4M",
  authDomain: "quiz-87a80.firebaseapp.com",
  projectId: "quiz-87a80",
  storageBucket: "quiz-87a80.firebasestorage.app",
  messagingSenderId: "409501561061",
  appId: "1:409501561061:web:3cf8137356db607e59240c",
  measurementId: "G-5Q20LZ07B3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// 🔥 Firestore DB (THIS WAS MISSING)
export const db = getFirestore(app);

// 🔐 Authentication (email/password user accounts)
export const auth = getAuth(app);

// Google Analytics is loaded via the gtag script in public/index.html
